import { Select, SelectProps } from "antd";
import { useEffect } from "react";
import SELECT_SEARCH_PROPS from "../../helpers/selectSearch";
import useFetchList from "../../hooks/useFetchList";
import { EApprovalStatus } from "../../types/approval.type";
import { EOfficeStatus, ListOfficeQuery, OfficeProperties } from "../../types/office.type";

interface Props extends SelectProps {
	excludeOfficeId?: string;
	officeList?: OfficeProperties[];
	setOfficeList?: React.Dispatch<React.SetStateAction<OfficeProperties[]>>;
	showOfficeCode?: boolean;
}
const SelectAllOffice: React.FC<Props> = ({ excludeOfficeId, officeList, setOfficeList, showOfficeCode, ...props }) => {
	const { data } = useFetchList<OfficeProperties, ListOfficeQuery>({
		endpoint: "offices",
		limit: 9999,
		initialQuery: {
			sort: "createdAt:DESC",
			offset: 0,
			filterApprovalStatus: EApprovalStatus.APPROVED,
			filterStatus: EOfficeStatus.PUBLISH,
		},
	});

	useEffect(() => {
		if (setOfficeList) {
			setOfficeList(data?.filter((v) => v.officeId !== excludeOfficeId));
		}
	}, [data]);

	return (
		<Select
			virtual={false}
			placeholder="Choose Office"
			className="no-ellipsis-option"
			{...SELECT_SEARCH_PROPS}
			options={data
				.filter((row) => row.officeId !== excludeOfficeId)
				.map((row) => ({
					value: row.officeId,
					label: showOfficeCode
						? row.officeName + " / " + (row.officeCode?.toUpperCase() ?? row.tempOfficeCode?.toUpperCase())
						: row.officeName,
					className: "no-ellipsis-option",
					officeCode: row.officeCode ?? row.tempOfficeCode,
				}))}
			{...props}
		/>
	);
};
export default SelectAllOffice;
